import {Grid, PassportIcon, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {i18n} from 'src/shared/config'
import {formatTime} from 'src/shared/utils'

import {useDetails} from '../hooks'
import {PaymentTitle} from './payment-title/PaymentTitle'
import {classes} from './PickupPointDetails.classes'
import {Props} from './types'

export function PickupPointDetails(props: Props) {
  const {result, point} = props
  const {time, schedule} = useDetails(point)

  return (
    <Grid className={classes.root} size="s" container>
      {point?.is_post_office && (
        <Grid alignItems="center" className={classes.passportNeed} size="m" container item>
          <Grid item>
            <PassportIcon fill="none" />
          </Grid>
          <Grid item>{i18n('ndd.pickup_points.passport_need', 'Для получения посылки нужен паспорт')}</Grid>
        </Grid>
      )}

      {result?.offers.length && (
        <Grid alignItems="center" justify="space-between" wrap="nowrap" container item>
          <Grid item xs>
            <Typography group="tight" variant="body2">
              {i18n('ndd.pickup_points.nearest_delivery', 'Ближайшая доставка')}
            </Typography>
          </Grid>
          <Grid alignItems="flex-end" direction="column" container item xs>
            <Typography group="tight" variant="body2">
              {formatTime(result)}
            </Typography>
          </Grid>
        </Grid>
      )}

      <Grid alignItems="center" justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.storage_time', 'Срок хранения')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          <Typography group="tight" variant="body2">
            {time}
          </Typography>
        </Grid>
      </Grid>

      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.schedule', 'График работы')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          {schedule.map((str, idx) => (
            <Typography key={idx} Component={Grid} group="tight" variant="body2" whiteSpace="nowrap">
              {str}
            </Typography>
          ))}
        </Grid>
      </Grid>

      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.payment_methods', 'Способы оплаты')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          {point?.payment_methods.map(method => (
            <PaymentTitle key={method} method={method} />
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}
